import { render, staticRenderFns } from "./GroupStatusChip.vue?vue&type=template&id=11d56e5c&scoped=true"
import script from "./GroupStatusChip.vue?vue&type=script&lang=js"
export * from "./GroupStatusChip.vue?vue&type=script&lang=js"
import style0 from "./GroupStatusChip.vue?vue&type=style&index=0&id=11d56e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d56e5c",
  null
  
)

export default component.exports